import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    fetchNewsList,
    createNews,
    updateNews,
    deleteNews
} from '../../../services/news';


export const fetchNewsListAsync = createAsyncThunk(
    'news/fetchList',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await fetchNewsList(params);
            return {
                news: response.data.data || [],
                total: response.data.total || 0
            };
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch news');
        }
    }
);
export const createNewsAsync = createAsyncThunk(
    'news/create',
    async (newsData, { rejectWithValue }) => {
        try {
            const response = await createNews(newsData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create news');
        }
    }
);

export const updateNewsAsync = createAsyncThunk(
    'news/update',
    async ({ newsId, newsData }, { rejectWithValue }) => {
        try {
            const response = await updateNews(newsId, newsData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to update news');
        }
    }
);

export const deleteNewsAsync = createAsyncThunk(
    'news/delete',
    async (newsId, { rejectWithValue }) => {
        try {
            const response = await deleteNews(newsId);
            return { newsId, ...response.data };
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to delete news');
        }
    }
);



const newsSlice = createSlice({
    name: 'news',
    initialState: {
        newsList: [],
        loading: false,
        error: null,
        total: 0,
        lastOperation: null
    },
    reducers: {
        clearLastOperation: (state) => {
            state.lastOperation = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewsListAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNewsListAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.newsList = action.payload.news;
                state.total = action.payload.total;
                state.error = null;
            })
            .addCase(fetchNewsListAsync.rejected, (state, action) => {
                state.loading = false;
                state.newsList = [];
                state.total = 0;
                state.error = action.payload;
            })

            .addCase(createNewsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createNewsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.newsList.push(action.payload);
                state.lastOperation = 'create';
            })
            .addCase(createNewsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(updateNewsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateNewsAsync.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.newsList.findIndex(news => news._id === action.payload._id);
                if (index !== -1) {
                    state.newsList[index] = action.payload;
                }
                state.lastOperation = 'update';
            })
            .addCase(updateNewsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(deleteNewsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteNewsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.newsList = state.newsList.filter(news => news._id !== action.payload.newsId);
                state.lastOperation = 'delete';
            })
            .addCase(deleteNewsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

    }
});

export const { clearLastOperation } = newsSlice.actions;
export default newsSlice.reducer;